export const Library = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Library</h1>
        </div>
    )
}